import 'bootstrap/dist/css/bootstrap.css';
import React, { useState, useEffect, useContext } from 'react';
import { Context } from "../contexts/siteContext";
import Card from "../card/card.js";
import CardHeader from "../card/cardHeader.js";
import CardBody from "../card/cardBody.js";
import { makeStyles } from "@material-ui/core/styles";
import {
    Container, createMuiTheme, Toolbar, Typography, FormLabel, CssBaseline,
    FormControlLabel, Checkbox, Button, TextField, Snackbar, FormControl, InputLabel, Select
} from '@material-ui/core';
import SaveIcon from '@material-ui/icons/Save';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import 'date-fns';
import { ThemeProvider } from '@material-ui/styles';
import { GlobalTheme } from '../../layouts/theme';
import { Link } from "react-router-dom";
import { ConvertToCurrentTimeZone, ConvertTimeToUTC } from '../header/timeFormatter';
import moment from 'moment';
import { Typeahead } from 'react-bootstrap-typeahead';
import DateFnsUtils from '@date-io/date-fns';
import { ValidatorForm } from 'react-material-ui-form-validator';
import { MuiPickersUtilsProvider, KeyboardDateTimePicker } from '@material-ui/pickers';
import { HttpService } from "../../apiAuthorization/httpService";
import data from '../../data';
import { authenticationService } from '../../apiAuthorization/authenticationService';
import FormatListBulletedIcon from '@material-ui/icons/FormatListBulleted'; import 'react-bootstrap-typeahead/css/Typeahead.css';
import MuiAlert from '@material-ui/lab/Alert';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import VisitaionLogList from '../visitationLog/visitationLogList';
import { ServiceRecovery } from '../contexts/serviceRecoveryContext';
import { AssignedToUsers } from '../contexts/assignedToUsers';
import { Theme } from '../contexts/themeContext';
import { Modules } from '../contexts/modulesContext';
import TeamProList from '../teamPro/teamProList';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles(theme => ({
    root: {
        '& > *': {
            margin: '10px 0px',
            width: '100%',
        },
    },
    button: {
        width: '15%',
        float: 'right'
    },
    error: {
        // right: 0,
        fontSize: '12px',
        fontWeight: "bold",
        color: 'red',
        // position: 'absolute',
        marginTop: '-5px',
    },
    colorCode: {
        marginRight: '5px', color: 'inherit'
    },
    legend: {
        width: '16px', height: '16px', display: 'inline-block'
    },
    listIcon: {
        float: 'left',
        marginRight: '5px'
    },
    listIconRight: {
        marginLeft: '25px'
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
}));

export default function ServiceRecoveryList(props) {
    //console.log("TN:" + props.taskNumber + "tp" + props.returnFromTP);
    const { defaultSite } = useContext(Context);
    const { theme } = useContext(Theme);
    const { recoveryIssue, issueLoaded, recoveryResolution, resolutionLoaded,
        getRecoveryIssue, getRecoveryResolution } = useContext(ServiceRecovery);
    const { assignedUsers, getAssignedToUsers } = useContext(AssignedToUsers);
    const { modules } = useContext(Modules);
    const [createTaskButtonVisible, setCreateTaskButtonVisible] = useState(false); 
    const [enableCreateTaskButton, setEnableCreateTaskButton] = useState(true);
    const [showTeamPro, setShowTeamPro] = useState(false);
    const [selectedDate, setSelectedDate] = useState(ConvertToCurrentTimeZone(new Date(), "MM/DD/YYYY hh:mm a", null, defaultSite));
    const [selected, setSelected] = useState(props.siteLocation ? props.siteLocation : []);
    const [roundState, setRoundState] = useState();
    const [locations, setLocations] = useState([]);
    const [appRecoveryId, setAppRecoveryId] = useState(0);
    const [patientName, setPatientName] = useState(props.patientName ? props.patientName : '');
    const [round, setRound] = useState();
    const [unsatisfactory, setUnsatisfactory] = useState(false);
    const [completed, setCompleted] = useState(false);
    const [confirmed, setConfirmed] = useState(false);
    const [issue, setIssue] = useState([]);
    const [resolution, setResolution] = useState([]);
    const [followUpSteps, setFollowUpSteps] = useState('');
    const [comment, setComment] = useState(props.comment ? props.comment : []);
    const [appVisitId, setAppVisitId] = useState(props.visitRecoveryId ? props.visitRecoveryId : 0);
    const [open, setOpen] = useState(false);
    const [saved, setSaved] = useState(false);
    const [forceOpen, setForceOpen] = useState(props.returnFromTP ? true : undefined);
    const [successMessage, setSuccessMessage] = useState(props.returnFromTP === true ? ("A new task " + (props.taskNumber ? props.taskNumber : '') + " has been created successfully in HRC system") : '');
    const [openSuccess, setOpenSuccess] = useState(props.returnFromTP ? true : false);
    const [errorMessage, setErrorMessage] = useState('');
    const [defaultManager, setDefaultManager] = useState([]);
    const [backDrop, setBackDrop] = useState(false);
    const [calledFromVL, setCalledFromVL] = useState(props.calledFromVL);
    const [taskNumber, setTaskNumber] = useState(null);
    const [requestDate, setRequestDate] = useState(null);
    const currentTheme = theme ? createMuiTheme(GlobalTheme[theme]) : createMuiTheme(GlobalTheme[localStorage.getItem("theme")]);

    const handleClose = () => {
        setOpen(false);
    };
    const handleCloseSuccess = () => {
        setOpenSuccess(false);
        setSelected([]);
        setSaved(false);
    };

    const validate = () => {
        if (issue.length === 0) {
            setErrorMessage('Please enter the issue.');
            setOpen(true);
            return false;
        }
        if (resolution.length === 0) {
            setErrorMessage('Please enter the resolution.');
            setOpen(true);
            return false;
        }
        if (defaultManager.length === 0) {
            setErrorMessage('Please enter the assigned to.');
            setOpen(true);
            return false;
        }
        if (unsatisfactory !== true) {
            setErrorMessage('Please check the Unsatisfactory.');
            setOpen(true);
            return false;
        }
        return true;
    }

    const handleAdd = (e) => {
       // console.log("appRecoveryId: " + appRecoveryId + selectedDate + selected[0].id + "round :" + round + defaultManager[0].id);
        if (!validate())
            return;
        setBackDrop(true);
        HttpService.post('/ServiceRecovery/UpdateAppRecovery', {
            AppRecoveryId: parseInt(appRecoveryId),
            RecoveryDate: selectedDate,
            GeoLocationAncestorId: defaultSite.id,
            GeoLocationId: selected[0].id,
            Recovery: parseInt(round),
            AssignedTo: defaultManager[0].id,
            AssignedToName: defaultManager[0].firstName + " " + defaultManager[0].lastName,
            Comment: comment,
            Unsatisfactory: Boolean(unsatisfactory),
            Completed: Boolean(completed),
            ManagerConfirmed: Boolean(confirmed),
            ResolutionActions: resolution[0].name,
            IssueProblem: issue[0].name,
            FollowUpSteps: followUpSteps,
            PatientName: patientName,
            CreatedUser: authenticationService.currentUserValue.username,
            ModifiedUser: authenticationService.currentUserValue.username,
            IsDeleted: Boolean(false),
            RequestedDatetime: ConvertToCurrentTimeZone(new Date(), "MM/DD/YYYY", null, defaultSite),
            AppVisitID: appVisitId.toString(), //visitLogId,
            ModifiedDateTime: ConvertTimeToUTC(new Date()),
            //TransactionStartLocal = transactionStartLocal,
            //TransactionEndLocal = transactionEndLocal,
            //SessionDuration = sessionDuration,
            //WarningCount = warningCount,
        })
            .then((result) => {
                //console.log("Service recovery: " + result.id );
                getListOfLocations();
                setAppRecoveryId(result.id);
                setSaved(true);
                setOpenSuccess(true);
                setSuccessMessage("The reccord added successfully");
                setForceOpen(true);
                setBackDrop(false);
                setCalledFromVL(false);
            },
                (error) => {
                    console.log(error);
                    setBackDrop(false);

                }
            );
    }

    const handleDateChange = date => {
        date = moment(date).format("MM/DD/YYYY hh:mm a")
        setSelectedDate(date);
    };

    const classes = useStyles();
    const getListOfLocations = () => {
        setBackDrop(true);
        HttpService.post('/ServiceRecovery/GetGeoLocationBranchRecoverys', {
            Date: selectedDate,
            Key: "GetAll",
            MaxId: -1,
            Site: defaultSite.id,
            GetAll: true,
            RecoveryState: 'All'
        })
            .then((result) => {
                console.log("Locations : " + result.data[0])
                setLocations(result.data);
                setBackDrop(false);

            },
                (error) => {
                    console.log(error);
                    setBackDrop(false);

                });
    }

    const checkCompleted = (e) => {
        setCompleted(e.target.checked);
        if (!unsatisfactory) setCompleted(false)
    }

    const checkConfirmed = (e) => {
        setConfirmed(e.target.checked);
        if (!unsatisfactory) setConfirmed(false)
    }

    const checkUnsatisfied = (e) => {
        setUnsatisfactory(e.target.checked);
        setCompleted(false);
        setConfirmed(false);
    }

    const viewServiceRecovery = (option, roundTag, roundNum) => {
        //console.log('View');
        if (roundTag !== null) {
            if (roundTag.AppRecoveryId === "0") {
                setRound(parseInt(roundNum));
                return;
            }
        }
        setBackDrop(true);
        HttpService.post("/ServiceRecovery/GetAppRecovery", {
            GeoLocationId: option === null ? selected[0].id : option.id,
            AppRecoveryId: roundTag === null ? parseInt(appRecoveryId) : parseInt(roundTag.AppRecoveryId),
            AppVisitID: appVisitId.toString()
        }).then((result) => {
            //console.log("view service: " + result.id);
            if (result.id !== -1) {
               // console.log("view service: " + result);
                setAppRecoveryId(result.id);
                setPatientName(props.patientName ? props.patientName : result.patientName);
                setComment(props.comment ? props.comment : result.comment);
                //var index = data.rounds.findIndex(x => (x.id === result.recovery));
                setRound(result.recovery ? result.recovery : 1);
                var index = recoveryResolution.findIndex(x => (x.name === result.resolutionActions))
                setResolution(recoveryResolution.slice(index, index + 1));

                index = recoveryIssue.findIndex(x => x.name === result.issueProblem);
                setIssue(recoveryIssue.slice(index, index + 1));

                index = assignedUsers.findIndex(x => x.id === result.assignedTo);
                setDefaultManager(assignedUsers.slice(index, index + 1));
                setTaskNumber(result.taskNumber);
                setRequestDate(result.requestDate);
                setConfirmed(result.managerConfirmed);
                setCompleted(result.completed);
                setUnsatisfactory(result.unsatisfactory);
                setFollowUpSteps(result.followUpSteps);
                setSaved(false);
                setForceOpen(undefined);
                //setRoundState(result.roundState);
            }
            setBackDrop(false);
        },
            (error) => {
                console.log(error);
                setBackDrop(false);
            });

    }
    const locationChanged = (e) => {
        setSelected(e);
        setForceOpen(undefined);
        setPatientName('');
        setIssue([]);
        setResolution([]);
        setDefaultManager([]);
        setFollowUpSteps('');
        setComment('');
        setUnsatisfactory(false);
        setCompleted(false);
        setConfirmed(false);
        setEnableCreateTaskButton(true);

        //setRound();
        //setRoundState(1);
    }

    useEffect(() => {
        setRoundState(1);
        getListOfLocations();
        setRound(1);
        if (assignedUsers.length === 0) getAssignedToUsers();
        if (recoveryIssue.length === 0) getRecoveryIssue();
        if (recoveryResolution.length === 0) getRecoveryResolution();
        if (defaultSite.IntegratedSystem.TaskMGMTSystemId !== null && modules.includes("TeamPRO")) {
            setCreateTaskButtonVisible(true);
        }
        // eslint-disable-next-line
    }, [selectedDate]);

    useEffect(() => {
        if (props.taskNumber === undefined && taskNumber === null && unsatisfactory === true && issue.length > 0 && defaultManager.length > 0 && resolution.length > 0) {
            setEnableCreateTaskButton(false);
        }
    }, [unsatisfactory, issue, resolution, defaultManager, props.taskNumber, taskNumber])

    useEffect(() => {
        //console.log("SV retunrned from tp " + props.returnFromTP + showTeamPro + props.returnFromSR);

        if (appVisitId > 0) {
            setAppVisitId(appVisitId);
            setPatientName(patientName);
            viewServiceRecovery(null, null, 1);
        }
         // eslint-disable-next-line
    }, [resolutionLoaded, issueLoaded]);

    const goToTeamPro = async () => {
        await handleAdd();
        setShowTeamPro(true);
    }

    return (
        <React.Fragment>
            {showTeamPro && <TeamProList theme={currentTheme} siteLocation={selected} appVisitId={props.appVisitId}
                recoveryId={appRecoveryId} patientName={patientName} comment={comment} calledFromSR={true} />}
            {!showTeamPro &&
                <ThemeProvider theme={currentTheme}>
                    <CssBaseline />
                    {saved && appVisitId > 0 && <VisitaionLogList returnFromSR={true} 
                        siteLocation={selected} theme={currentTheme} />}
                    {(appVisitId === 0 || calledFromVL) && <>
                        <Backdrop className={classes.backdrop} open={backDrop}>
                            <CircularProgress color="inherit" />
                        </Backdrop>
                        <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
                            <Alert onClose={handleClose} severity="error">
                                {errorMessage}
                            </Alert>
                        </Snackbar>
                        <Snackbar open={openSuccess} autoHideDuration={6000} onClose={handleCloseSuccess}>
                            <Alert onClose={handleCloseSuccess} severity="success">
                                {successMessage}
                            </Alert>
                        </Snackbar>
                        <Container maxWidth="xl">

                            <Card color="primary" style={{ height: '100%', background: currentTheme.background }}>
                                <CardHeader color="primary" style={{ background: currentTheme.palette.primary }} >
                                    <div style={{ display: 'flex' }}>
                                        <Toolbar style={{ width: '85%' }}>
                                            <Link to="/"><KeyboardBackspaceIcon /></Link>
                                            <Typography variant="h6" className={classes.title}>
                                                Service Recovery
                                </Typography>
                                        </Toolbar>
                                        {selected.length > 0 && createTaskButtonVisible===true && <Button
                                            variant="contained"
                                            color="primary"
                                            size="medium"
                                            disabled={enableCreateTaskButton}
                                            className={classes.button}
                                            style={{ background: currentTheme.secondary, width: 'auto', margin: 'auto' }}
                                            type="submit"
                                            onClick={goToTeamPro}
                                        >
                                            Create Task
                                        </Button>
                                        }
                                    </div>
                                </CardHeader>
                                <CardBody style={{ color: currentTheme.text }}>

                                    <ValidatorForm className={classes.root} autoComplete="off" onSubmit={handleAdd}>
                                        <div id="recoveryLog_colorLegend">
                                            <label className={classes.colorCode} ><span className={classes.legend} style={{ backgroundColor: '#e8c5c5' }}>&nbsp;</span>&nbsp;Unsatisfactory</label>
                                            <label className={classes.colorCode} ><span className={classes.legend} style={{ backgroundColor: '#f8efc2' }}>&nbsp;</span>&nbsp;Completed</label>
                                            <label className={classes.colorCode} ><span className={classes.legend} style={{ backgroundColor: '#c9e5be' }}>&nbsp;</span>&nbsp;Manager Confirmed</label>
                                        </div>

                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                            <KeyboardDateTimePicker autoOk
                                                inputVariant="outlined"
                                                label="Date"
                                                format="MM/dd/yyyy hh:mm a"
                                                size="small"
                                                disableFuture="true"
                                                value={selectedDate}
                                                InputAdornmentProps={{ position: "start" }}
                                                onChange={date => handleDateChange(date)}
                                            />
                                        </MuiPickersUtilsProvider>
                                        <FormControl variant="outlined" margin="dense" className={classes.ddl}>
                                            <InputLabel htmlFor="outlined-age-native-simple">Round State</InputLabel>
                                            <Select
                                                native
                                                onChange={(e) => { setRoundState(e.target.value); console.log("roundState change" + e.target.value) }}
                                                label="Round State"
                                                size="small"
                                                value={roundState}
                                            >
                                                <option aria-label="None" key="0" value="" />
                                                {
                                                    data.roundStates.map((option, key) => {
                                                        return <option key={option.id} value={option.id} label={option.name} >{option.name}</option>;
                                                    })
                                                }
                                            </Select>
                                        </FormControl>
                                        <Typeahead
                                            id="basic-typeahead-example"
                                            labelKey="name"
                                            onChange={(e) => locationChanged(e)}
                                            options={locations}
                                            placeholder="Choose a Location..."
                                            selected={selected}
                                            open={forceOpen} // Forced to keep it open drop down after saving
                                            renderMenuItemChildren={(option, key) => (
                                                <>
                                                    <div key={option.id} className="dropdown-widget">
                                                        <div className="left" >{option.name}</div>
                                                        <div className="round-tags swiper-wrapper width-auto">
                                                            <div >
                                                                {option.recovery_Color_1_List.map((color, key) => (
                                                                    <span key={key} className={'RecoveryShift round-tag ' + color.Recovery1Color} onClick={e => { viewServiceRecovery(option, color, 1) }} >1</span>
                                                                ))}
                                                                {option.recovery_Color_2_List.map((color, key) => (
                                                                    <span key={key} className={'RecoveryShift round-tag ' + color.Recovery2Color} onClick={e => { viewServiceRecovery(option, color, 2); setRound(parseInt(2)) }}>2</span>
                                                                ))}
                                                                {option.recovery_Color_3_List.map((color, key) => (
                                                                    <span key={key} className={'RecoveryShift round-tag ' + color.Recovery3Color} onClick={e => viewServiceRecovery(option, color, 3)}>3</span>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            )}
                                        />

                                        {(selected.length > 0 && !saved) &&
                                            <>
                                                <FormControl variant="outlined" margin="dense" className={classes.ddl}>
                                                    <InputLabel htmlFor="outlined-age-native-simple">Round</InputLabel>
                                                    <Select
                                                        native
                                                        onChange={(e) => { setRound(e.target.value); console.log("round change" + e.target.value) }}
                                                        label="Round"
                                                        size="small"
                                                        value={round}
                                                    >
                                                        <option aria-label="None" key="0" value="" />
                                                        {
                                                            data.rounds.map((option, key) => {
                                                                return <option key={option.id} value={option.id} label={option.name} >{option.name}</option>;
                                                            })
                                                        }
                                                    </Select>
                                                </FormControl>

                                                <FormLabel className="selLocation">Location : {selected[0].name}</FormLabel>
                                                <FormControlLabel
                                                    style={{ width: 'auto', margin: '0px 5px', color: 'inherit' }}
                                                    value="start"
                                                    control={<Checkbox style={{ color: currentTheme.secondary }} checked={unsatisfactory} />}
                                                    label="Unsatisfactory"
                                                    labelPlacement="start"
                                                    onChange={e => checkUnsatisfied(e)}
                                                />
                                                <TextField style={{ marginTop: '0px' }}
                                                    label="Patient Last Name, First Initial"
                                                    onChange={e => setPatientName(e.target.value)}
                                                    name="email"
                                                    required
                                                    value={patientName}
                                                    variant="outlined"
                                                    size="small"
                                                />

                                                <Typeahead style={{ marginTop: '0px' }}
                                                    id="RecoveryIssue"
                                                    labelKey="name"
                                                    onChange={setIssue}
                                                    options={recoveryIssue}
                                                    placeholder="Choose a Issue/Problem..."
                                                    selected={issue}
                                                    defaultSelected={issue}
                                                    renderMenuItemChildren={(option, key) => (
                                                        <div className="dropdown-widget" >
                                                            {option.pid === 0 ? (
                                                                <>
                                                                    <FormatListBulletedIcon fontSize="small" className={classes.listIcon} />
                                                                    <div className="left" >{option.name}</div>
                                                                </>)
                                                                :
                                                                <div className={classes.listIconRight}>{option.name}</div>
                                                            }
                                                        </div>
                                                    )}
                                                />

                                                <Typeahead
                                                    id="RecoveryResolution"
                                                    labelKey="name"
                                                    onChange={setResolution}
                                                    options={recoveryResolution}
                                                    placeholder="Choose a Resolution/Actions..."
                                                    selected={resolution}
                                                    defaultSelected={resolution}
                                                    renderMenuItemChildren={(option, key) => (
                                                        <div className="dropdown-widget">
                                                            {option.pid === 0 ? (
                                                                <>
                                                                    <FormatListBulletedIcon fontSize="small" className={classes.listIcon} />
                                                                    <div className="left">{option.name}</div>
                                                                </>)
                                                                :
                                                                <div className={classes.listIconRight}>{option.name}</div>
                                                            }
                                                        </div>
                                                    )}
                                                />

                                                <Typeahead
                                                    id="labelkey-example"
                                                    labelKey={(option) => `${option.firstName} ${option.lastName}`}
                                                    onChange={setDefaultManager}
                                                    options={assignedUsers}
                                                    placeholder="Choose a Manager assigned..."
                                                    selected={defaultManager}
                                                    defaultSelected={defaultManager}
                                                    renderMenuItemChildren={(option, key) => (
                                                        <div className="dropdown-widget">
                                                            <div className="left">{option.firstName} {option.lastName}</div>
                                                        </div>
                                                    )}
                                                />
                                                <TextField style={{ marginTop: '0px' }}
                                                    label="Follow-Up Steps"
                                                    onChange={e => setFollowUpSteps(e.target.value)}
                                                    name="email"
                                                    value={followUpSteps}
                                                    variant="outlined"
                                                    size="small"
                                                />

                                                <TextField style={{ marginTop: '0px' }}
                                                    label="Comment"
                                                    onChange={e => setComment(e.target.value)}
                                                    name="email"
                                                    value={comment}
                                                    variant="outlined"
                                                    size="small"
                                                />

                                                <FormControlLabel
                                                    style={{ width: 'auto', margin: '0px 5px', color: 'inherit' }}
                                                    value="start"
                                                    control={<Checkbox style={{ color: currentTheme.secondary }} checked={completed} />}
                                                    label="Completed"
                                                    labelPlacement="start"
                                                    onChange={e => checkCompleted(e)}
                                                />

                                                <FormControlLabel
                                                    style={{ width: 'auto', margin: '0px 5px', color: 'inherit' }}
                                                    value="start"
                                                    control={<Checkbox style={{ color: currentTheme.secondary }} checked={confirmed} />}
                                                    label="Managet Confirmed"
                                                    labelPlacement="start"
                                                    onChange={e => checkConfirmed(e)}
                                                />
                                                {taskNumber && <div className="nav-address">
                                                    <i className="icon-location-3"></i>Task '{taskNumber}' created in HRC on {requestDate} , Status: Unassigned.
                                        </div>
                                                }
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    size="small"
                                                    className={classes.button}
                                                    style={{ background: currentTheme.secondary, width: 'auto' }}
                                                    startIcon={<SaveIcon />}
                                                    type="submit"
                                                >
                                                    Save
                                        </Button>
                                            </>
                                        }
                                    </ValidatorForm>
                                </CardBody>
                            </Card>
                        </Container>
                    </>
                    }
                </ThemeProvider>
            }
        </React.Fragment>
    )
}